// extracted by mini-css-extract-plugin
export default {"result-title":"_result-title_uhBaRR","result-descr":"_result-descr_2IgVWL"};